<template>
    <div class="settings__page">
        <div class="mt--30">
            <FormLabel title="Welcome to Ziner" html-for="info" label-type="title" />
            <p class="text--sm text-gray-600 mt--3">
                Let's help you get started. To start, check off the items in the list below by completing them.
            </p>
        </div>

        <div class="mt--30">
            <FormLabel :title="`Onboarding checklist (${completedCount}/${checklist.length})`" html-for="info" label-type="title" />

            <div class="row__item relative pl--0 mt--30 gap-3 grid">
                <div v-for="item in checklist" :key="item.id" class="checklist-item" :class="{ 'disabled': item.isCompleted }">
                    <div class="project__share__icon" :style="{ background: checklistMap[item.id]?.bgColor }">
                        <IconSvg :name="checklistMap[item.id]?.iconName" :fill="checklistMap[item.id]?.textColor" />
                    </div>
                    <div>
                        <p class="text--semi--bold text--sm text-gray-600">
                            {{ checklistMap[item.id]?.title || "" }}
                        </p>
                        <p class="text--sm text-gray-500">
                            {{ checklistMap[item.id]?.desc || "" }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    FormLabel,
    IconSvg,
} from "@/components/ui/index";

export default {
    name: "GettingStartedPage",

    components: {
        IconSvg,
        FormLabel,
    },

    beforeRouteEnter(to, from, next) {        
        next(async(vm) => {            
            if (to.name === "getting-started") {    
                const isListCompleted = vm.checklist?.length ? vm.checklist.every(x => x.isCompleted) : false;

                if (isListCompleted) {
                    return vm.$router.push({ name: "reports", query: { type: "clients", range: "1_year" } });
                }
            }
        });
    },

    data() {
        return {
            checklistMap: {
                "client": {
                    title: "Create your first client",
                    desc: "Add a new client - potential leads or active clients.",
                    iconName: "user",
                    bgColor: "#ecbffe",
                    textColor: "#691298",
                },
                "project": {
                    title: "Create your first project",
                    desc: "Now's the time to start something new.",
                    iconName: "folder",
                    bgColor: "#fac993",
                    textColor: "#c16106",
                },
                "invoice": {
                    title: "Send your first invoice",
                    desc: "Send an invoice to a client for paid projects.",
                    iconName: "receipt",
                    bgColor: "#abf5b3",
                    textColor: "#054f0a",
                },
                "task": {
                    title: "Create your first task",
                    desc: "Stay organized with work. Tick off completed tasks.",
                    iconName: "task",
                    bgColor: "#a1deff",
                    textColor: "#0768a3",
                },
            },
        };
    },

    computed: {
        profile() {
            return this.$store.getters["auth/profile"];
        },

        invoices() {
            return this.$store.getters["invoice/invoices"] || [];
        },

        projects() {
            return this.$store.getters["project/projects"];
        },

        clients() {
            return this.$store.getters["clients/clients"];
        },

        tasks() {
            return this.$store.getters["task/tasks"] || [];
        },

        checklist() {
            return this.$store.getters["app/checks"] || [];
        },

        isListCompleted() {
            return this.checklist?.length ? this.checklist.every(x => x.isCompleted) : false;
        },

        completedCount() {
            return this.checklist.filter(x => x.isCompleted)?.length || 0;
        },
    },

    watch: {
        isListCompleted(newVal) {
            if (newVal) {
                this.$store.dispatch("app/toggleConfetti", {
                    show: true,
                    type: "onboarding confetti",
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
    .settings__page {
        max-width: 50%;
    }

   .checklist-item {
        border: 1px dotted #01010e75;
        border-radius: 10px;
        padding: 15px 10px;
        gap: 15px;
        display: flex;
        align-items: center;
        width: 100%;

        &.disabled {
            background: #eeeeee7e;
        }

        &.shake {

        }
   }
</style>